import React from 'react';
import { Badge, BadgeProps, Tooltip } from '@chakra-ui/react';
import { ruleSetDescription, ruleSetLabel } from '../../utils/ruleSet';

interface RuleSetBadgeProps extends BadgeProps {
  ruleSet?: string;
}

/** A competition's rule set, in words where the code has a label; the code itself on hover. */
export const RuleSetBadge: React.FC<RuleSetBadgeProps> = ({ ruleSet, ...badgeProps }) => {
  const description = ruleSetDescription(ruleSet);
  const badge = <Badge colorScheme="purple" cursor={description ? 'help' : undefined} {...badgeProps}>{ruleSetLabel(ruleSet)}</Badge>;
  return description ? <Tooltip label={description} placement="top">{badge}</Tooltip> : badge;
};

export default RuleSetBadge;
